import client from '../../../../../api/client';


export const attendanceRegularizationApi = {
  getList: async (params = {}) => {
    try {
      const response = await client.get('/self-service/attendance-regularization/', { params });
      return {
        data: response.data.items || [],
        total: response.data.total_count || (response.data.items || []).length,
      };
    } catch (err) {
      console.warn('Failed to fetch regularizations:', err);
      return { data: [], total: 0 };
    }
  },

  getById: async (id) => {
    try {
      const response = await client.get(`/self-service/attendance-regularization/${id}`);
      return response.data;
    } catch (err) {
      console.warn(`Failed to fetch regularization #${id}:`, err);
      return null;
    }
  },

  getReasons: async () => {
    try {
      const response = await client.get('/self-service/attendance-regularization/reasons');
      return response.data || [];
    } catch (err) {
      console.warn('Failed to fetch regularization reasons:', err);
      return [];
    }
  },

  create: async (data) => {
    const formattedHour = String(data.timeHour || '09').padStart(2, '0');
    const formattedMin = String(data.timeMinute || '30').padStart(2, '0');
    let hourNum = parseInt(formattedHour, 10);
    if (data.timeAmPm === 'pm' && hourNum < 12) hourNum += 12;
    if (data.timeAmPm === 'am' && hourNum === 12) hourNum = 0;
    const time24 = `${String(hourNum).padStart(2, '0')}:${formattedMin}:00`;
    const dateStr = data.date || new Date().toISOString().split('T')[0];

    const payload = {
      EmpId: Number(data.EmpId || data.empId || 1),
      TDateTime: `${dateStr} ${time24}`,
      ReasonId: Number(data.ReasonId || data.reasonId || 1),
      Remarks: data.Remarks || data.remarks || '',
      GPSIn: data.GPSIn || data.gpsIn || 'Main Office',
      IsApproved: 0,
      name: data.name,
      employeeId: data.employeeId || data.empId,
      date: dateStr,
      time: `${formattedHour}:${formattedMin} ${(data.timeAmPm || 'am').toUpperCase()}`,
      reason: data.reason,
      status: 'Pending',
    };
    const response = await client.post('/self-service/attendance-regularization/', payload);
    return response.data;
  },

  update: async (id, data) => {
    const response = await client.put(`/self-service/attendance-regularization/${id}`, data);
    return response.data;
  },

  approve: async (id, isApproved) => {
    const response = await client.post(`/self-service/attendance-regularization/${id}/approve`, {
      is_approved: isApproved ? 1 : 2,
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await client.delete(`/self-service/attendance-regularization/${id}`);
    return response.data;
  },
};
